<template>
  <aside :class="sidebarClass" id="cbp-spmenu-s1">
    <div id="sidebar" class="sidebar">
      <i class="fa fa-times" @click="closeSidebar"></i>
    </div>
    <div class="menu-container">
      <nav class="main-menu" id="main-menu">
        <router-link to="/" class="home">
          <div class="icon-logo" alt="Home"></div>
          <div class="site-title">Saint Lucia NEIS</div>
        </router-link>
        <div class="routes">
          <sidebar-link v-for="route in routes" :key="route" :route="route"></sidebar-link>
        </div>
      </nav>
      <nav class="user-info" id="user-info" v-if="isAuthenticated">
        <div class="user-content">
          <span class="user-name">{{ fullName }}</span>
          <div class="logout-content" @click="confirmAction()">
            <span class="icon-logout"></span>
            <span class="logout">Logout</span>
            <span id="app-version">Version 1.00</span>
          </div>
        </div>
      </nav>
    </div>
  </aside>
</template>


<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import store from '../store'
import { dashboard_routes } from '../routes'
import  SidebarLink from './SidebarLink'
import { bus } from '../main'


export default {
    data () {
        return {
            routes: dashboard_routes,
            opened: false
        }
    },

    computed : {
      ...mapState({
        fullName: function (state) {
            const user = state.user;
            return (user)? user.first_name+" "+user.last_name : user.email
        }
      }),
      ...mapGetters([
          // map `this.doneCount` to `this.$store.getters.doneTodosCount`
          'isAuthenticated'
        ]),
      sidebarClass: function(){
        if(this.opened){
          return 'cbp-spmenu cbp-spmenu-vertical cbp-spmenu-left open'
        }else{
          return 'cbp-spmenu cbp-spmenu-vertical cbp-spmenu-left'
        }
      },

    },
    components: {SidebarLink},
    mounted(){
      let sideBar = this
      bus.$on('toggle-sidebar', function(){
        sideBar.opened = !sideBar.opened;
      });
    },
    methods: {
        isPermitted: function(route){
            return store.getters.hasPerm(route.meta.requiresPerm);
        },

      confirmAction: function() {
        let _this = this;
        this.$confirm({
            title: 'Logout ' + this.fullName,
            content: 'Are you sure you want to log out this user?',
          }).then(() => {
            store.dispatch('logoutUser');
            this.$router.push('/');
            }).catch(() => {
              this.$notify(this.fullName+' is still logged in.')
            });
      },
      toggleSidebar: function(){
        this.opened = !this.opened;
      },
      closeSidebar: function(){
        console.log("here")
        this.opened = false;
      }
    }
}

</script>


<style lang="scss">
@import "../css/constants";
@import "../css/box";

aside {
  position: relative;
  overflow: hidden;
  padding-right: 0;
  z-index: 10;
  @include box(auto, 17rem, #f9f9f9);
  @include flow(column, no-wrap);
  @include stretch-spread;
  font-family: 'Roboto Slab', serif;

  z-index: 99999;
  border-right: 1px solid #eaeaea;

  transition: all 0.5s ease-in-out 0s;
  -webkit-transition: all 0.5s ease-in-out 0s;
  -o-transition: all 0.5s ease-in-out 0s;

  &.open{
    display: block;
  }

  #sidebar { 
    width: 100%;  
    display: none !important;  
    color: $gray4; 
    text-align: right;
    padding: 10px;
    
    cursor: pointer;
    z-index: 9999;
    i:before { font-size: 1.6em;  }
    &:hover, &:focus, &:visited, &:active { color: #56CCF2; }
  }
      
  nav {
    .home {
      //changes
      display: inline-block;
      text-align: center;
      width: 100%;
      transition: all 0.4s cubic-bezier(0.82, 0.04, 0.25, 1);
      height: auto;

      .icon-logo { margin-left: auto; }
      .site-title{
        
        margin-top: 15px;
        font-weight:Bold;
        font-size: 16px;
        width: 100%;
      }
    }

    a {
      display: flex;
      align-items: center;
      color: #6b6b6b;
      height: 2.5rem;
      margin-left: 0rem;
      margin-bottom: 0.5rem;
      padding-left: 2rem;
      text-decoration: none;
      
      a:hover, a:focus, a:visited { text-decoration: none; }
    }

    a.home{ margin: 30px 0 20px; padding: 0px; }

    a.sidebar-menu-item.router-link-active {
      box-shadow: inset 4px 0px 0 0 #04bafc;
      color: #FFFFFF;
      font-family:  'Roboto Slab', serif;
      font-weight: 'Bold';
      background-color: #04bafc;
      text-decoration: none;
    }
  }
  
  nav.main-menu {
    width: 100%;
    span { opacity: 1; font-size: 0.875em; }
  }
  
  nav.main-menu.active {
    span { opacity: 0; }
  }

  .user-info {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 15px 0;
    text-align: center;
    z-index: 999;
    border-right: 1px solid #eaeaea;
    
    span {
      opacity: 1;
      transition: all 0.6s cubic-bezier(0.46, 0.01, 0.09, 1);
    }
    
    span#app-version {
      font-size: 12px;
      color: $gray6;
      display: block;
      margin-top: 10px;
    }
    
    section:first-child {
      margin-bottom: $p16;
    }
  }
  
  .user-info.active {
    span {
      opacity: 0;
      display: none;
    }
  }
  
  .user-content {    
    margin: 0 auto;
    text-align: center;
    
    .user-name {
      display: block;
      margin-bottom: 3px;
      color: #337ab7; 
      font-size: 15.5px;
    }
    
    .logout-content {
      cursor: pointer;
      
      .icon-logout {
        display: inline-block; 
        margin-bottom: -2%;
        font-size: 8px;
        
        &:hover { opacity:0%; }
      }
      .logout {
        font-size: 14px; 
        padding-bottom: 10px; 
      }
    }
  }
}
.routes{
    margin-top: 20px;
    font-size: 16.5px;
}
.end {
    margin-left: 2rem;
    padding-bottom: 1%;
}

@media only screen and (min-width: 768px) {
  /* For mobile phones: */
  aside { 
    .main-menu{  
      height: calc(100vh - 90px); 
      overflow-y: auto; 
      overflow-x: hidden;
      vertical-align: top;
      vertical-align: top;
      padding-bottom: 0px;
      
      &::-webkit-scrollbar { width: 2px; }
      &::-webkit-scrollbar-track-piece { background-color: transparent; }
      &::-webkit-scrollbar-track {
      // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
      background-color: transparent;
      border-radius: 30px;
      }

      &::-webkit-scrollbar-thumb {
      cursor: pointer;
      background: -webkit-linear-gradient(to right, #35B8FB, #56CCF2);
      background: linear-gradient(to right, #35B8FB, #56CCF2);
      outline: 1px solid slategrey;

      border-radius: 30px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 

      &:hover { background: #35B8FB; }
      }
    }
    
    .user-info {
      width: 100%;
      background: #f9f9f9;
      border-right: 1px solid #eaeaea;  
    }
  }
}

@media only screen and (min-width: 468px) and (max-width: 900px) {
  /* For mobile phones: */
  aside { 
    @include box(auto, 14rem, #f9f9f9);
    position: absolute;
    top: 0;
    left: -105%;
    width: 50vw;
    height: 100vh;
    vertical-align: text-top;
    
    /* box shadow */
    -webkit-box-shadow: 10px 0 25px -10px #888;
       -moz-box-shadow: 10px 0 25px -10px #888;
            box-shadow: 10px 0 25px -10px #888;    

    &.open{ left: 0%; }    
    .routes { margin: 0; padding: 0; }    
    .sidebar:before { font-size: 1.8em; }
    
    #sidebar { display: block !important; }
    
    nav { 
      a.home{ margin: 15px 0; padding: 0px; }
    }
    
    .menu-container { height: 100vh; }
    .main-menu {  
      height: 100vh;  
      overflow-y: auto; 
      overflow-x: hidden;
      vertical-align: top;
      
      padding-bottom: 135px;
      
      &::-webkit-scrollbar { width: 2px; }
      &::-webkit-scrollbar-track-piece { background-color: transparent; }
      &::-webkit-scrollbar-track {
      // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
      background-color: transparent;
      border-radius: 30px;
      }

      &::-webkit-scrollbar-thumb {
      cursor: pointer;
      background: -webkit-linear-gradient(to right, #35B8FB, #56CCF2);
      background: linear-gradient(to right, #35B8FB, #56CCF2);
      outline: 1px solid slategrey;

      border-radius: 30px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 

      &:hover { background: #35B8FB; }
      }
    }
        
    .user-info {
      width: 100%;
      border-top: 1px solid #eaeaea;
      background: #f9f9f9;      
    }  
  }
}

@media only screen and (max-width: 468px) {
  /* For mobile phones: */
  aside { 
    @include box(auto, 0rem, #f9f9f9);
    position: absolute;
    top: 0;
    left: -105%;
    width: 100vw;
    height: 100vh;
    vertical-align: text-top;
    
    /* box shadow */
    -webkit-box-shadow: 10px 0 25px -10px #888;
       -moz-box-shadow: 10px 0 25px -10px #888;
            box-shadow: 10px 0 25px -10px #888;
    

    &.open{ left: 0%; }
    .routes { margin: 0; padding: 0; }    
    .sidebar:before { font-size: 1.8em; }
        
    #sidebar { display: block !important; }
    nav { a.home{ margin: 15px 0; padding: 0px; }
    }

    .main-menu{  
      height: 100vh; 
      overflow-y: auto; 
      overflow-x: hidden;
      vertical-align: top;
      vertical-align: top;
      
      padding-bottom: 135px;
      
      &::-webkit-scrollbar { width: 2px; }
      &::-webkit-scrollbar-track-piece { background-color: transparent; }
      &::-webkit-scrollbar-track {
      // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
      background-color: transparent;
      border-radius: 30px;
      }

      &::-webkit-scrollbar-thumb {
      cursor: pointer;
      background: -webkit-linear-gradient(to right, #35B8FB, #56CCF2);
      background: linear-gradient(to right, #35B8FB, #56CCF2);
      outline: 1px solid slategrey;

      border-radius: 30px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
      -ms-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 

      &:hover { background: #35B8FB; }
      }
    }
        
    .user-info {
      width: 100%;
      border-top: 1px solid #eaeaea;
      background: #f9f9f9;
      border-right: 1px solid #eaeaea;    
    }  
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue